import Button from "@mui/material/Button";
import React from "react";

interface GoogleButtonProps {
  mode: "login" | "register";
}

export const GoogleLoginButton: React.FC<GoogleButtonProps> = ({ mode }) => {
  const backendPath = process.env.REACT_APP_BACKEND_URL;
  const handleGoogleLogin = () => {
    window.location.href = `${backendPath}/auth?frontend=${window.location.origin}`;
  };
  return (
    <Button
      color="primary"
      onClick={() => handleGoogleLogin()}
      variant="contained"
    >
      {mode === "login" ? "Login" : "Register"} with Google
    </Button>
  );
};
